import VueI18n from "vue-i18n";
import Vue from "vue";

import ko from "./assets/locales/ko.json";
import ja from "./assets/locales/ja.json";
import th from "./assets/locales/th.json";
import en from "./assets/locales/en.json";
import tw from "./assets/locales/zh-TW.json";
import hk from "./assets/locales/zh-HK.json";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "ja", // set locale
  fallbackLocale: "en", // set fallback locale
  messages: {
    ko,
    ja,
    th,
    en,
    "zh-TW": tw,
    "zh-HK": hk,
  },
});

export default i18n;
